<template>
  <div class="container mt-5">
    <h2><i class="fa fa-question-circle" style="font-size:26px"></i>&nbsp;FAQ</h2>
    <div class="sticky-search-bar">
      <div class="input-group mb-3">
        <span class="input-group-text" style="margin: 0"><i class="fa fa-search" style="font-size: 26px"></i></span>
        <input type="text" class="form-control" v-model="searchQuery">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="clearSearch">
            <i class="fa fa-refresh" style="font-size:26px"></i>
          </button>
        </div>
      </div>
      <div class="input-group mb-3">
        <span class="input-group-text" style="margin: 0;padding: 0"><i class="fa fa-language"
                                                                       style="font-size: 31px"></i></span>
        <select class="custom-select mr-2" v-model="selectedLanguage">
          <option value="en" selected="selected">English</option>
          <option value="zh">中文</option>
        </select>&nbsp;&nbsp;
        <span class="input-group-text" style="margin: 0;padding: 0"><i class="fa fa fa-print"
                                                                       style="font-size: 31px"></i></span>
        <select class="custom-select" v-model="selectedModel">
          <option value="N20" selected="selected">N20</option>
          <option value="N12">N12</option>
          <option value="N80">N80</option>
          <option value="D20">D20</option>
          <option value="D21">D21</option>
        </select>
      </div>
    </div>
    <div class="accordion" id="faqAccordion">
      <div v-for="(item, index) in filteredItems" :key="index" class="card">
        <div class="card-header" :id="`heading${index}`">
          <h2 class="mb-0">
            <button class="btn d-flex align-items-center w-100" style="font-weight: 800;text-align: left" type="button"
                    data-toggle="collapse"
                    :data-target="`#collapse${index}`"
                    :aria-expanded="isExpanded[index]" :aria-controls="`collapse${index}`" @click="toggleExpand(index)">
              {{ item.question }}
              <i class="fas fa-caret-down" :class="{ 'rotate': isExpanded[index] }"></i>
            </button>
          </h2>
        </div>
        <div :id="`collapse${index}`" class="collapse" :class="{ 'show': isExpanded[index] }"
             :aria-labelledby="`heading${index}`" data-parent="#faqAccordion">
          <div class="card-body">
            <div class="answer-text">{{ item.answer }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, computed, watch, onMounted} from 'vue';
import {useRoute} from 'vue-router';

export default {
  setup() {
    const route = useRoute();
    const searchQuery = ref('');
    const selectedLanguage = ref(
        route.query.lang && route.query.lang.startsWith('zh') ? 'zh' : 'en'
    );
    const selectedModel = ref(route.query.equipment || 'N20');
    const faqItems = ref([
          {
            "question": "新手产品使用顺序",
            "answer": "拿到新设备，首次使用请先充电，长按电源3秒后开机；\n下载Nada print app，在App Store/Google Play搜索\"Nada print\"下载安装；\n打开手机蓝牙，APP搜索设备并连接，开始打印",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "打印机快速使用",
            "answer": "(1)按住电源按钮三秒钟打开打印机\n(2)按下开盖杆打开顶盖\n(3)取出纸盒中现有的纸卷\n(4)将导板锁推向电源按钮，直到听到咔嗒声以解锁导板\n(5)将导板尽可能向外滑动\n(6)从纸卷上取下防松贴纸\n(7)将纸卷放入纸盒中\n(8)将导板向内滑动至纸卷边缘\n(9)将导板锁推向纸盒盖，直到听到咔嗒声以锁定导板\n(10)将标签纸延伸到出纸口上方，然后关闭顶盖",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "指示灯问题",
            "answer": "(1)电源按钮，长按3秒，进行开/关机\n(2)重置孔，使用细针按压，重启打印机\n(3)绿灯亮，正常操作\n(4)绿灯缓缓闪烁，打印\n(5)红绿灯交替闪烁，升级\n(6)红灯亮，打开纸张隔间\n(7)红绿灯交替闪烁，加热头过热，建议等红灯变绿\n(8)红灯亮，未检测到纸张或者故障，建议重新安装标签纸\n(9)红灯缓缓闪烁，电池电量低，及时充电\n(10)绿灯快速闪烁是充电，绿灯常亮是充电完成",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "打印机连接不上",
            "answer": "(1)请先确认打印机正常开机，蓝牙正常开启\n(2)是否在app内进行设备连接，andriod手机需打开定位权限\n(3)机器是否正在连接其它设备，打印机暂无法同时与多台手机进行连接\n(4)如果还是无法连接，在开机状态下双击电源键，打印出打印机的信息，并查看app搜索到打印机列表内是否有该打印机，点击进行连接\n(5)尝试联系客服",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "打印不清晰",
            "answer": "(1)检查默认打印浓度以获得最佳打印效果，如果不行请调整打印浓度，\n(2)打印头是否堵塞，并用少许酒精清洁打印头，需注意清洁时要关机，待酒精挥发后才开机使用\n(3)打印纸保存选择避光，干燥环境",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "打印空白",
            "answer": "检查纸张是否正确放置，尝试调整耗材出纸口长度，将耗材延伸到出纸口上方，拉出出纸口2CM，保证正常出纸",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "耗材适配",
            "answer": "购买打印机会配置对应的耗材",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "默认编辑的标签尺寸是多少",
            "answer": "首次编辑默认标签尺寸为40mm*30mm",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "更换打印纸",
            "answer": "推动/按下开盖键机身轻轻弹开，打开上盖后，将打印纸拉直伸平，放入纸仓，合盖，完成安装和更换",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "其它问题",
            "answer": "(1)内置锂电池，请勿在超过40°C的环境中使用；远离火源和其他热源，不要放在烈日下，例如封闭的汽车内；\n(2)儿童应在成人监护下充电和使用；\n(3)充满电后请及时拔掉充电线，以防止过热、短路或火灾；\n(4)不要将产品放入火中或水中以避免电池短路或火灾；\n(5)操作温度范围为0°C至40°C，请不超过推荐的温度范围；",
            "language": "zh",
            "model": "N20"
          },
          {
            "question": "Product usage order for beginners",
            "answer": "When you get a new device, charge it for the first time and press and hold the power button for 3 seconds to turn it on;\nDownload the Nada print app, search for \"Nada print\" in the App Store/Google Play to download and install;\nTurn on the Bluetooth of your phone, search for the device in the APP and connect, then start printing",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Quickly operate the printer",
            "answer": "(1)Press and hold the power button for three seconds to turn on the printer\n(2)Press down the Cover Open Lever to open the Top Cover\n(3)Remove the existing paper roll in the Paper Compartment\n(4)Push the Guide Lock towards the Power Button until you hear a click to unlock the Guides\n(5)Slide the Guides outwards as far as they can go\n(6)Remove the Anti-loosening Sticker from the paper roll\n(7)Place the paper roll in the Paper Compartment\n(8)Slide the Guides inwards to the edges of the paper roll\n(9)Push the Guide Lock towards the Paper Compartment Cover until you hear a click to lock the Guides\n(10)Extend the label paper out above the Paper Outlet and\nthen close the Top Cover",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Light problem",
            "answer": "(1)Power button, press and hold for 3 seconds to turn on/off\n(2)Reset hole, press with a fine needle to restart the printer\n(3)Green light on, normal operation\n(4)Green light flashes slowly, printing\n(5)Red and green lights flash alternately, upgrade\n(6)Red light on, open the paper compartment\n(7)Red and green lights flash alternately, the heating head is overheated, it is recommended to wait for the red light to turn green\n(8)Red light on, no paper is detected or there is a fault, it is recommended to reinstall the label paper\n(9)Red light flashes slowly, the battery is low, charge in time\n(10)The green light flashes quickly when charging, and the green light is always on when charging is complete",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Printer cannot be connected.",
            "answer": "(1)Please make sure that the printer is turned on normally and Bluetooth is turned on normally\n(2)Please confirm whether the Bluetooth connection is made in the app, Android phones need to enable location permissions\n(3)Is the machine connecting to other devices? The printer cannot connect to multiple phones at the same time\n(4)If it still cannot connect, double-click the power button when the machine is turned on, print out the printer information, and check whether the printer is in the printer list searched by the app, and click to connect\n(5)Try to contact customer service",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Unclear printing",
            "answer": "(1)Check the default print density to get the best printing effect. If it doesn't work, adjust the print density.\n(2)Check if the print head is clogged. Use a little alcohol to clean the print head. Please turn off the machine when cleaning. Wait until the alcohol evaporates before turning it on.\n(3)Store the printing paper in a dry and dark environment",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Print blank",
            "answer": "Check whether the paper is placed correctly, try to adjust the length of the paper outlet, pull the paper out of the outlet 2CM to ensure normal paper output",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Consumables adaptation",
            "answer": "When you buy a printer, you will be provided with the corresponding consumables.",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "What is the default edited label size?",
            "answer": "The default label size for the first edit is 40mm*30mm",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Changing the printer paper",
            "answer": "Push/press the cover open button and the machine body will pop open gently. After opening the top cover, straighten and flatten the printing paper, put it into the paper bin, close the cover, and the installation and replacement are completed.",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "Other issues",
            "answer": "1. Built-in lithium battery, do not use in more than 40°C environment; Keep away from fire and other heat sources, not in the hot sun, such as in a closed car;\n2. Children should charge and use under adult supervision;\n3. Please unplug the charging cable in time after fully charged to prevent overheating, short circuit or fire;\n4. Do not put the product into fire or water to avoid battery short circuit or fire;\n5. The operating temperature range is 0°C to 40°C, please do not exceed the recommended temperature range",
            "language": "en",
            "model": "N20"
          },
          {
            "question": "新手产品使用顺序",
            "answer": "拿到新设备，首次使用请先充电，长按电源3秒后开机；\n下载Nada print app，在App Store/Google Play搜索\"Nada print\"下载安装；\n打开手机蓝牙，APP搜索设备并连接，开始打印",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "打印机快速使用",
            "answer": "(1)打开顶盖\n(2)撕掉纸卷上的保护贴纸\n(3)插入纸卷\n(4)关上顶盖",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "指示灯问题",
            "answer": "(1)电源按钮，长按3秒，进行开/关机\n(2)重置孔，使用细针按压，重启打印机\n(3)绿灯亮，正常操作\n(4)绿灯缓缓闪烁，打印\n(5)红绿灯交替闪烁，升级\n(6)红灯亮，打开纸张隔间\n(7)红绿灯交替闪烁，加热头过热，建议等红灯变绿\n(8)红灯亮，未检测到纸张或者故障，建议重新安装标签纸\n(9)红灯缓缓闪烁，电池电量低，及时充电\n(10)绿灯快速闪烁是充电，绿灯常亮是充电完成",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "APP扫码连接打印机",
            "answer": "开机后双击电源键打印二维码 → 打开「Nada Print」APP → 点击搜索页扫码按钮 → 扫码连接",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "打印机连接不上",
            "answer": "(1)请先确认打印机正常开机，蓝牙正常开启\n(2)是否在app内进行设备连接，andriod手机需打开定位权限\n(3)机器是否正在连接其它设备，打印机暂无法同时与多台手机进行连接\n(4)如果还是无法连接，在开机状态下双击电源键，打印出打印机的信息，并查看app搜索到打印机列表内是否有该打印机，点击进行连接\n(5)尝试联系客服",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "打印不清晰",
            "answer": "(1)检查默认打印浓度以获得最佳打印效果，如果不行请调整打印浓度，\n(2)打印头是否堵塞，并用少许酒精清洁打印头，需注意清洁时要关机，待酒精挥发后才开机使用\n(3)打印纸保存选择避光，干燥环境",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "打印空白",
            "answer": "检查纸张是否正确放置，尝试调整耗材出纸口长度，将耗材延伸到出纸口上方，拉出出纸口2CM，保证正常出纸",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "耗材适配",
            "answer": "购买打印机会配置对应的耗材",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "更换打印纸",
            "answer": "单手握住两侧开盖键机身轻轻打开上盖后，将打印纸拉直伸平，放入纸仓，合盖，完成安装和更换",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "其它问题",
            "answer": "1、内置锂电池，请勿在超过40°C的环境中使用；远离火源和其他热源，不要放在烈日下，例如封闭的汽车内；\n2、儿童应在成人监护下充电和使用；\n3、充满电后请及时拔掉充电线，以防止过热、短路或火灾；\n4、不要将产品放入火中或水中以避免电池短路或火灾；\n5、操作温度范围为0°C至40°C，请不超过推荐的温度范围",
            "language": "zh",
            "model": "D20"
          },
          {
            "question": "Product usage order for beginners",
            "answer": "When you get a new device, charge it for the first time and press and hold the power button for 3 seconds to turn it on;\nDownload the Nada print app, search for \"Nada print\" in the App Store/Google Play to download and install;\nTurn on the Bluetooth of your phone, search for the device in the APP and connect, then start printing",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Quickly operate the printer",
            "answer": "(1)Open the top cover\n(2)Remove the protective sticker from the paper roll\n(3)Insert the paper roll \n(4)Close the top cover",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Light problem",
            "answer": "(1)Power button, press and hold for 3 seconds to turn on/off\n(2)Reset hole, press with a fine needle to restart the printer\n(3)Green light on, normal operation\n(4)Green light flashes slowly, printing\n(5)Red and green lights flash alternately, upgrade\n(6)Red light on, open the paper compartment\n(7)Red and green lights flash alternately, the heating head is overheated, it is recommended to wait for the red light to turn green\n(8)Red light on, no paper is detected or there is a fault, it is recommended to reinstall the label paper\n(9)Red light flashes slowly, the battery is low, charge in time\n(10)The green light flashes quickly when charging, and the green light is always on when charging is complete",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "APP scan code to connect to the printer",
            "answer": "Double-click the power button after turning on\nthe machine to print the QR code → Open the\n\"Nada Print\" APP → Click the scan code button\non the search page → Scan the code to connect.",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Printer cannot be connected.",
            "answer": "(1)Please make sure that the printer is turned on normally and Bluetooth is turned on normally\n(2)Please confirm whether the Bluetooth connection is made in the app, Android phones need to enable location permissions\n(3)Is the machine connecting to other devices? The printer cannot connect to multiple phones at the same time\n(4)If it still cannot connect, double-click the power button when the machine is turned on, print out the printer information, and check whether the printer is in the printer list searched by the app, and click to connect\n(5)Try to contact customer service",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Unclear printing",
            "answer": "(1)Check the default print density to get the best printing effect. If it doesn't work, adjust the print density.\n(2)Check if the print head is clogged. Use a little alcohol to clean the print head. Please turn off the machine when cleaning. Wait until the alcohol evaporates before turning it on.\n(3)Store the printing paper in a dry and dark environment",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Print blank",
            "answer": "Check whether the paper is placed correctly, try to adjust the length of the paper outlet, pull the paper out of the outlet 2CM to ensure normal paper output",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Consumables adaptation",
            "answer": "When you buy a printer, you will be provided with the corresponding consumables.",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Changing the printer paper",
            "answer": "Hold the cover open buttons on both sides of the machine with one hand and gently open the upper cover. Straighten and flatten the printing paper, put it into the paper bin, close the cover, and the installation and replacement are completed",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "Other issues",
            "answer": "1. Built-in lithium battery, do not use in an environment exceeding 40°C; keep away from fire and other heat sources, do not place under the scorching sun, such as in a closed 22°C car;\n2. Children should charge and use under adult supervision;\n3. Please unplug the charging cable in time after fully charged to prevent overheating, short circuit or fire;\n4. Do not put the product into fire or water to avoid battery short circuit or fire;\n5. The operating temperature range is 0°C to 40°C, please do not exceed the recommended temperature range",
            "language": "en",
            "model": "D20"
          },
          {
            "question": "新手产品使用顺序",
            "answer": "拿到新设备，首次使用请先充电，长按电源3秒后开机；\n下载Nada print app，在App Store/Google Play搜索\"Nada print\"下载安装；\n打开手机蓝牙，APP搜索设备并连接，开始打印",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "打印机快速使用",
            "answer": "(1)向左滑动以打开盖子\n(2)将打印纸放入隔间时，打印面朝下，并确保第一张标签纸从撕口处伸出。\n(3)合上盖子，准备打印",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "打印机连接不上",
            "answer": "(1)请先确认打印机正常开机，蓝牙正常开启\n(2)是否在app内进行设备连接，andriod手机需打开定位权限\n(3)机器是否正在连接其它设备，打印机暂无法同时与多台手机进行连接\n(4)如果还是无法连接，在开机状态下双击电源键，打印出打印机的信息，并查看app搜索到打印机列表内是否有该打印机，点击进行连接\n(5)尝试联系客服",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "打印机基础的操作有哪些",
            "answer": "(1)开机：按住电源按钮3秒钟\n(2)关机：设备开启时，按住电源按钮3秒钟",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "如何打印测试页？",
            "answer": "设备开启时，双击电源按钮",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "打印不清晰",
            "answer": "(1)检查默认打印浓度以获得最佳打印效果，如果不行请调整打印浓度，\n(2)打印头是否堵塞，并用少许酒精清洁打印头，需注意清洁时要关机，待酒精挥发后才开机使用\n(3)打印纸保存选择避光，干燥环境",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "默认编辑的标签尺寸是多少",
            "answer": "首次编辑默认标签尺寸为14mm*40mm",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "耗材适配",
            "answer": "购买打印机会配置对应的耗材",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "打印空白",
            "answer": "检查纸张是否正确放置，尝试调整耗材出纸口长度，将耗材拉出出纸口2CM，保证正常出纸",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "其它问题",
            "answer": "(1)内置锂电池，请勿在超过40°C的环境中使用；远离火源和其他热源，不要放在烈日下，例如封闭的汽车内；\n(2)儿童应在成人监护下充电和使用；\n(3)充满电后请及时拔掉充电线，以防止过热、短路或火灾；\n(4)不要将产品放入火中或水中以避免电池短路或火灾；\n(5)操作温度范围为0°C至40°C，请不超过推荐的温度范围；",
            "language": "zh",
            "model": "N12"
          },
          {
            "question": "Product usage order for beginners",
            "answer": "When you get a new device, charge it for the first time and press and hold the power button for 3 seconds to turn it on;\nDownload the Nada print app, search for \"Nada print\" in the App Store/Google Play to download and install;\nTurn on the Bluetooth of your phone, search for the device in the APP and connect, then start printing",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "Quickly operate the printer",
            "answer": "(1)Slide left to open the lid\n(2)Insert the print paperinto thecompartment with the printed sidefacing down, and ensure the first label paper extends out of the tear-off opening\n(3)Cover the lid and prepare to print",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "Printer cannot be connected.",
            "answer": "(1)Please make sure that the printer is turned on normally and Bluetooth is turned on normally\n(2)Please confirm whether the Bluetooth connection is made in the app, Android phones need to enable location permissions\n(3)Is the machine connecting to other devices? The printer cannot connect to multiple phones at the same time\n(4)If it still cannot connect, double-click the power button when the machine is turned on, print out the printer information, and check whether the printer is in the printer list searched by the app, and click to connect\n(5)Try to contact customer service",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "What are the basic operations of the printer?",
            "answer": "(1)Switch on：Hold down the Power button for 3 seconds\n(2)Switch off：Hold down the Power button for 3 seconds when the device is on",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "Print a test page",
            "answer": "Double-press the Power button when the device is on",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "Unclear printing",
            "answer": "(1)Check the default print density to get the best printing effect. If it doesn't work, adjust the print density.\n(2)Check if the print head is clogged. Use a little alcohol to clean the print head. Please turn off the machine when cleaning. Wait until the alcohol evaporates before turning it on.\n(3)Store the printing paper in a dry and dark environment",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "What is the default edited label size?",
            "answer": "The default label size for the first edit is 14mm*40mm",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "Consumables adaptation",
            "answer": "When you buy a printer, you will be provided with the corresponding consumables.",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "Print blank",
            "answer": "Check whether the paper is placed correctly, try to adjust the length of the paper outlet, pull the paper out of the outlet 2CM to ensure normal paper output",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "Other issues",
            "answer": "1. Built-in lithium battery, do not use in more than 40°C environment; Keep away from fire and other heat sources, not in the hot sun, such as in a closed car;\n2. Children should charge and use under adult supervision;\n3. Please unplug the charging cable in time after fully charged to prevent overheating, short circuit or fire;\n4. Do not put the product into fire or water to avoid battery short circuit or fire;\n5. The operating temperature range is 0°C to 40°C, please do not exceed the recommended temperature range",
            "language": "en",
            "model": "N12"
          },
          {
            "question": "新手产品使用顺序",
            "answer": "拿到新设备，首次使用请先充电，长按电源3秒后开机；\n下载Nada print app，在App Store/Google Play搜索\"Nada print\"下载安装；\n打开手机蓝牙，APP搜索设备并连接，开始打印",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "打印机快速使用",
            "answer": "(1)打开顶盖\n(2)撕掉纸卷上的保护贴纸\n(3)插入纸卷\n(4)关上顶盖",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "指示灯问题",
            "answer": "(1)电源按钮，长按3秒，进行开/关机\n(2)重置孔，使用细针按压，重启打印机\n(3)绿灯亮，正常操作\n(4)绿灯缓缓闪烁，打印\n(5)红绿灯交替闪烁，升级\n(6)红灯亮，打开纸张隔间\n(7)红绿灯交替闪烁，加热头过热，建议等红灯变绿\n(8)红灯亮，未检测到纸张或者故障，建议重新安装标签纸\n(9)红灯缓缓闪烁，电池电量低，及时充电\n(10)绿灯快速闪烁是充电，绿灯常亮是充电完成",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "APP扫码连接打印机",
            "answer": "开机后双击电源键打印二维码 → 打开「Nada Print」APP → 点击搜索页扫码按钮 → 扫码连接",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "打印机连接不上",
            "answer": "(1)请先确认打印机正常开机，蓝牙正常开启\n(2)是否在app内进行设备连接，andriod手机需打开定位权限\n(3)机器是否正在连接其它设备，打印机暂无法同时与多台手机进行连接\n(4)如果还是无法连接，在开机状态下双击电源键，打印出打印机的信息，并查看app搜索到打印机列表内是否有该打印机，点击进行连接\n(5)尝试联系客服",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "打印不清晰",
            "answer": "(1)检查默认打印浓度以获得最佳打印效果，如果不行请调整打印浓度，\n(2)打印头是否堵塞，并用少许酒精清洁打印头，需注意清洁时要关机，待酒精挥发后才开机使用\n(3)打印纸保存选择避光，干燥环境",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "打印空白",
            "answer": "检查纸张是否正确放置，尝试调整耗材出纸口长度，将耗材延伸到出纸口上方，拉出出纸口2CM，保证正常出纸",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "耗材适配",
            "answer": "购买打印机会配置对应的耗材",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "更换打印纸",
            "answer": "单手握住两侧开盖键机身轻轻打开上盖后，将打印纸拉直伸平，放入纸仓，合盖，完成安装和更换",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "其它问题",
            "answer": "1、内置锂电池，请勿在超过40°C的环境中使用；远离火源和其他热源，不要放在烈日下，例如封闭的汽车内；\n2、儿童应在成人监护下充电和使用；\n3、充满电后请及时拔掉充电线，以防止过热、短路或火灾；\n4、不要将产品放入火中或水中以避免电池短路或火灾；\n5、操作温度范围为0°C至40°C，请不超过推荐的温度范围",
            "language": "zh",
            "model": "D21"
          },
          {
            "question": "Product usage order for beginners",
            "answer": "When you get a new device, charge it for the first time and press and hold the power button for 3 seconds to turn it on;\nDownload the Nada print app, search for \"Nada print\" in the App Store/Google Play to download and install;\nTurn on the Bluetooth of your phone, search for the device in the APP and connect, then start printing",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Quickly operate the printer",
            "answer": "(1)Open the top cover\n(2)Remove the protective sticker from the paper roll\n(3)Insert the paper roll \n(4)Close the top cover",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Light problem",
            "answer": "(1)Power button, press and hold for 3 seconds to turn on/off\n(2)Reset hole, press with a fine needle to restart the printer\n(3)Green light on, normal operation\n(4)Green light flashes slowly, printing\n(5)Red and green lights flash alternately, upgrade\n(6)Red light on, open the paper compartment\n(7)Red and green lights flash alternately, the heating head is overheated, it is recommended to wait for the red light to turn green\n(8)Red light on, no paper is detected or there is a fault, it is recommended to reinstall the label paper\n(9)Red light flashes slowly, the battery is low, charge in time\n(10)The green light flashes quickly when charging, and the green light is always on when charging is complete",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "APP scan code to connect to the printer",
            "answer": "Double-click the power button after turning on\nthe machine to print the QR code → Open the\n\"Nada Print\" APP → Click the scan code button\non the search page → Scan the code to connect.",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Printer cannot be connected.",
            "answer": "(1)Please make sure that the printer is turned on normally and Bluetooth is turned on normally\n(2)Please confirm whether the Bluetooth connection is made in the app, Android phones need to enable location permissions\n(3)Is the machine connecting to other devices? The printer cannot connect to multiple phones at the same time\n(4)If it still cannot connect, double-click the power button when the machine is turned on, print out the printer information, and check whether the printer is in the printer list searched by the app, and click to connect\n(5)Try to contact customer service",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Unclear printing",
            "answer": "(1)Check the default print density to get the best printing effect. If it doesn't work, adjust the print density.\n(2)Check if the print head is clogged. Use a little alcohol to clean the print head. Please turn off the machine when cleaning. Wait until the alcohol evaporates before turning it on.\n(3)Store the printing paper in a dry and dark environment",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Print blank",
            "answer": "Check whether the paper is placed correctly, try to adjust the length of the paper outlet, pull the paper out of the outlet 2CM to ensure normal paper output",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Consumables adaptation",
            "answer": "When you buy a printer, you will be provided with the corresponding consumables.",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Changing the printer paper",
            "answer": "Hold the cover open buttons on both sides of the machine with one hand and gently open the upper cover. Straighten and flatten the printing paper, put it into the paper bin, close the cover, and the installation and replacement are completed",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "Other issues",
            "answer": "1. Built-in lithium battery, do not use in an environment exceeding 40°C; keep away from fire and other heat sources, do not place under the scorching sun, such as in a closed 22°C car;\n2. Children should charge and use under adult supervision;\n3. Please unplug the charging cable in time after fully charged to prevent overheating, short circuit or fire;\n4. Do not put the product into fire or water to avoid battery short circuit or fire;\n5. The operating temperature range is 0°C to 40°C, please do not exceed the recommended temperature range",
            "language": "en",
            "model": "D21"
          },
          {
            "question": "新手产品使用顺序",
            "answer": "拿到新设备，首次使用请先充电，长按电源3秒后开机；\n下载Nada print app，在App Store/Google Play搜索\"Nada print\"下载安装；\n打开手机蓝牙，APP搜索设备并连接，开始打印",
            "language": "zh",
            "model": "N80"
          },
          {
            "question": "指示灯问题",
            "answer": "(1)电源按钮，长按3秒，进行开/关机\n(2)重置孔，使用细针按压，重启打印机\n(3)绿灯亮，正常操作\n(4)绿灯缓缓闪烁，打印\n(5)红绿灯交替闪烁，升级\n(6)红灯亮，打开纸张隔间\n(7)红绿灯交替闪烁，加热头过热，建议等红灯变绿\n(8)红灯亮，未检测到纸张或者故障，建议重新安装标签纸\n(9)红灯缓缓闪烁，电池电量低，及时充电\n(10)绿灯快速闪烁是充电，绿灯常亮是充电完成",
            "language": "zh",
            "model": "N80"
          },
          {
            "question": "打印机连接不上",
            "answer": "(1)请先确认打印机正常开机，蓝牙正常开启\n(2)是否在app内进行设备连接，andriod手机需打开定位权限\n(3)机器是否正在连接其它设备，打印机暂无法同时与多台手机进行连接\n(4)如果还是无法连接，在开机状态下双击电源键，打印出打印机的信息，并查看app搜索到打印机列表内是否有该打印机，点击进行连接\n(5)尝试联系客服",
            "language": "zh",
            "model": "N80"
          },
          {
            "question": "打印不清晰",
            "answer": "(1)检查默认打印浓度以获得最佳打印效果，如果不行请调整打印浓度，\n(2)打印头是否堵塞，并用少许酒精清洁打印头，需注意清洁时要关机，待酒精挥发后才开机使用\n(3)打印纸保存选择避光，干燥环境",
            "language": "zh",
            "model": "N80"
          },
          {
            "question": "耗材适配",
            "answer": "购买打印机会配置对应的耗材",
            "language": "zh",
            "model": "N80"
          },
          {
            "question": "其它问题",
            "answer": "(1)内置锂电池，请勿在超过40°C的环境中使用；远离火源和其他热源，不要放在烈日下，例如封闭的汽车内；\n(2)儿童应在成人监护下充电和使用；\n(3)充满电后请及时拔掉充电线，以防止过热、短路或火灾；\n(4)不要将产品放入火中或水中以避免电池短路或火灾；\n(5)操作温度范围为0°C至40°C，请不超过推荐的温度范围；",
            "language": "zh",
            "model": "N80"
          },
          {
            "question": "Product usage order for beginners",
            "answer": "When you get a new device, charge it for the first time and press and hold the power button for 3 seconds to turn it on;\nDownload the Nada print app, search for \"Nada print\" in the App Store/Google Play to download and install;\nTurn on the Bluetooth of your phone, search for the device in the APP and connect, then start printing",
            "language": "en",
            "model": "N80"
          },
          {
            "question": "Light problem",
            "answer": "(1)Power button, press and hold for 3 seconds to turn on/off\n(2)Reset hole, press with a fine needle to restart the printer\n(3)Green light on, normal operation\n(4)Green light flashes slowly, printing\n(5)Red and green lights flash alternately, upgrade\n(6)Red light on, open the paper compartment\n(7)Red and green lights flash alternately, the heating head is overheated, it is recommended to wait for the red light to turn green\n(8)Red light on, no paper is detected or there is a fault, it is recommended to reinstall the label paper\n(9)Red light flashes slowly, the battery is low, charge in time\n(10)The green light flashes quickly when charging, and the green light is always on when charging is complete",
            "language": "en",
            "model": "N80"
          },
          {
            "question": "Printer cannot be connected.",
            "answer": "(1)Please make sure that the printer is turned on normally and Bluetooth is turned on normally\n(2)Please confirm whether the Bluetooth connection is made in the app, Android phones need to enable location permissions\n(3)Is the machine connecting to other devices? The printer cannot connect to multiple phones at the same time\n(4)If it still cannot connect, double-click the power button when the machine is turned on, print out the printer information, and check whether the printer is in the printer list searched by the app, and click to connect\n(5)Try to contact customer service",
            "language": "en",
            "model": "N80"
          },
          {
            "question": "Unclear printing",
            "answer": "(1)Check the default print density to get the best printing effect. If it doesn't work, adjust the print density.\n(2)Check if the print head is clogged. Use a little alcohol to clean the print head. Please turn off the machine when cleaning. Wait until the alcohol evaporates before turning it on.\n(3)Store the printing paper in a dry and dark environment",
            "language": "en",
            "model": "N80"
          },
          {
            "question": "Consumables adaptation",
            "answer": "When you buy a printer, you will be provided with the corresponding consumables.",
            "language": "en",
            "model": "N80"
          },
          {
            "question": "Other issues",
            "answer": "1. Built-in lithium battery, do not use in more than 40°C environment; Keep away from fire and other heat sources, not in the hot sun, such as in a closed car;\n2. Children should charge and use under adult supervision;\n3. Please unplug the charging cable in time after fully charged to prevent overheating, short circuit or fire;\n4. Do not put the product into fire or water to avoid battery short circuit or fire;\n5. The operating temperature range is 0°C to 40°C, please do not exceed the recommended temperature range",
            "language": "en",
            "model": "N80"
          }
        ]
    );
    const isExpanded = ref([]);
    const filteredItems = computed(() => {
      return faqItems.value.filter(item => {
        const query = searchQuery.value.toLowerCase();
        const matchesSearch = item.question.toLowerCase().includes(query);
        const answerMatch = item.answer.toLowerCase().includes(query);
        const matchesLanguage = !selectedLanguage.value || item.language === selectedLanguage.value;
        const matchesModel = !selectedModel.value || item.model === selectedModel.value;
        return (matchesSearch || answerMatch) && matchesLanguage && matchesModel;
      });
    });

    const clearSearch = () => {
      searchQuery.value = '';
    };

    const toggleExpand = (index) => {
      isExpanded.value[index] = !isExpanded.value[index];
    };

    onMounted(() => {
      isExpanded.value = faqItems.value.map((_, i) => i === 0);
    });

    watch(() => route.query.selectedModel, (newVal) => {
      selectedModel.value = newVal || 'N20';
    });

    watch(() => route.query.selectedLanguage, (newVal) => {
      selectedLanguage.value = newVal || 'en';
    });
    return {
      searchQuery,
      selectedLanguage,
      selectedModel,
      faqItems,
      isExpanded,
      filteredItems,
      clearSearch,
      toggleExpand
    };
  }
};
</script>

<style scoped>
.input-group {
  display: flex;
  align-items: center;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-right: 0.5rem;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem 0 0 0.25rem;
}

.form-control {
  flex: 1;
  padding-left: 1rem; /* 调整以适应图标 */
}

.input-group-append .btn {
  border-radius: 0 0.25rem 0.25rem 0;
}

.answer-text {
  white-space: pre-wrap; /* 保留空格和换行符，并允许文本自动换行 */
  text-align: left;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rotate {
  transform: rotate(180deg);
}

.card-header {
  cursor: pointer;
}

.sticky-search-bar {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000; /* 确保搜索栏在其他内容之上 */
}

/* 箭头图标旋转 */
.rotate {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

/* 按钮样式调整 */
.btn-link {
  text-decoration: none;
  color: inherit;
}

/* 箭头图标样式 */
.fa-chevron-down {
  transition: transform 0.3s ease;
}

/* 下拉菜单的样式调整 */
.custom-select {
  border: 1px solid #ced4da; /* 与输入框相同的边框颜色 */
  border-radius: 0.25rem; /* 圆角 */
  padding: 0.375rem 0.75rem; /* 内边距 */
  font-size: 1rem; /* 字体大小 */
  line-height: 1.5; /* 行高 */
  color: #495057; /* 文字颜色 */
  background-color: #fff; /* 背景颜色 */
  background-clip: padding-box; /* 背景裁剪 */
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; /* 平滑过渡效果 */
}

/* 下拉菜单选项的样式调整 */
.custom-select option {
  color: #495057; /* 选项文字颜色 */
  background-color: #fff; /* 选项背景颜色 */
}

/* 下拉菜单聚焦时的样式 */
.custom-select:focus {
  border-color: #80bdff; /* 聚焦时的边框颜色 */
  outline: 0; /* 去掉默认的轮廓线 */
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); /* 聚焦时的阴影效果 */
}

/* 下拉菜单的宽度调整 */
.input-group-append .custom-select {
  width: auto; /* 自动宽度 */
  margin-left: 0.5rem; /* 左边距 */
}

/* 按钮的样式调整 */
.btn-outline-secondary {
  border: 1px solid #ced4da; /* 与输入框相同的边框颜色 */
  border-radius: 0.25rem; /* 圆角 */
  padding: 0.375rem 0.75rem; /* 内边距 */
  font-size: 1rem; /* 字体大小 */
  line-height: 1.5; /* 行高 */
  color: #495057; /* 文字颜色 */
  background-color: transparent; /* 透明背景 */
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; /* 平滑过渡效果 */
}

/* 按钮聚焦时的样式 */
.btn-outline-secondary:focus {
  color: #007bff; /* 聚焦时的文字颜色 */
  border-color: #80bdff; /* 聚焦时的边框颜色 */
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); /* 聚焦时的阴影效果 */
}
</style>
